export default __webpack_public_path__ + "static/media/large-button-spinner.110eff18.svg";